export const DEFAULT_RUBRIC_LANGUAGE_LINK = 'https://www.pdesas.org/EducatorFrameworks/EducatorEffectiveness?SectionPageItemId=12201';
